export default __webpack_public_path__ + "TRIBE Content Licence Agreement.pdf";